import {
  DOCUMENT_LIST_REQUEST,
  DOCUMENT_LIST_SUCCESS,
  DOCUMENT_LIST_FAIL,
  DOCUMENT_CREATE_REQUEST,
  DOCUMENT_CREATE_SUCCESS,
  DOCUMENT_CREATE_FAIL,
  DOCUMENT_DELETE_REQUEST,
  DOCUMENT_DELETE_SUCCESS,
  DOCUMENT_DELETE_FAIL,
} from "../constants/documentConstants";
import api from "../core/api";

export const listDocuments = (docJson) => async (dispatch, getState) => {
  try {
    dispatch({ type: DOCUMENT_LIST_REQUEST });

    const { provider, providerId, docType, PageSize, PageNo } = docJson;

    const { data } = await api.get(
      "/accounts/document/" +
        provider +
        "/" +
        providerId +
        "/" +
        docType +
        "/" +
        PageSize +
        "/" +
        PageNo
    );

    dispatch({
      type: DOCUMENT_LIST_SUCCESS,
      payload: data.Result,
      total: data.totalDocuments,
    });
  } catch (error) {
    dispatch({
      type: DOCUMENT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createDocuments =
  (docJson, providerName) => async (dispatch, getState) => {
    try {
      dispatch({ type: DOCUMENT_CREATE_REQUEST });

      const { data } = await api.post(
        "/accounts/document/" + providerName,
        docJson
      );

      dispatch({
        type: DOCUMENT_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: DOCUMENT_CREATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deleteDocuments = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DOCUMENT_DELETE_REQUEST });
    const { data } = await api.delete(
      `/accounts/document/${id}`
    );

    dispatch({
      type: DOCUMENT_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DOCUMENT_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
